import { render, staticRenderFns } from "./ValorPlano.vue?vue&type=template&id=3cb59c11&"
import script from "./ValorPlano.vue?vue&type=script&lang=js&"
export * from "./ValorPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports